<ng-container *ngIf="merchant">
  <div class="merchant">
    <h2 class="title">
      {{ merchant.company }}
    </h2>
  </div>

  <div
    class="balance"
    [class.visible]="(overviewMode$ | async) === OverviewModesEnum.TRANSACTIONS"
  >
    <div class="balance-payment">
      <div class="value">
        <ng-container *ngIf="currentLanguage$ | async as language">
          <span class="amount">
            {{
              (totalPayment ? totalPayment : 0) / 100
                | currency: currencyPayment:"symbol":"":language.key
            }}
          </span>
        </ng-container>
      </div>
      <div class="caption">
        <small>
          {{ "home.merchant.balance-payment" | translate }}
        </small>
      </div>
    </div>
  </div>
</ng-container>
